import { render, staticRenderFns } from "./UploadRecording.vue?vue&type=template&id=497a5971&scoped=true&"
import script from "./UploadRecording.vue?vue&type=script&setup=true&lang=js&"
export * from "./UploadRecording.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a5971",
  null
  
)

export default component.exports